import * as React from 'react';
import { Box, Drag } from '../../ui';

type Props = {
  dragHandleProps?: any;
  title: string;
  id: string;
  isSectionItem?: boolean;
  closeSidebar?: () => void;
  setSectionHovered?: (arg0: boolean) => void;
};

function handleClick(
  e: React.MouseEvent<HTMLDivElement>,
  id: string,
  closeSidebar?: () => void
) {
  e.preventDefault();
  closeSidebar && closeSidebar();
  const targetEl = document.querySelector(`#nav-${id}`);
  if (targetEl) {
    targetEl.scrollIntoView({ behavior: 'smooth' });
  }
}

const SidebarRow = ({
  dragHandleProps,
  title,
  id,
  isSectionItem,
  closeSidebar,
  setSectionHovered = () => {},
}: Props) => (
  <Box
    sx={{
      variant: 'flex.verticalCenter',
      width: '100%',
      paddingLeft: isSectionItem ? 4 : 0,
    }}
    onMouseEnter={() => !isSectionItem && setSectionHovered(true)}
    onMouseLeave={() => !isSectionItem && setSectionHovered(false)}
  >
    <Box
      {...dragHandleProps}
      sx={{
        variant: 'text.base',
        color: 'black70',
        py: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        cursor: 'pointer !important',
        ':hover': {
          color: 'black',
        },
      }}
      as="a"
      href={`#nav-${id}`}
      onClick={(e) => handleClick(e, id, closeSidebar)}
    >
      {title}
      <Drag
        sx={{
          opacity: [1, 1, 0],
          cursor: 'grab',
          transition: 'opacity 150ms ease-in-out',
          display: id === 'aboutid' ? 'none' : 'block',
        }}
        className={isSectionItem ? 'dragItem' : 'dragSection'}
      />
    </Box>
  </Box>
);

export default SidebarRow;
